export default __webpack_public_path__ + "60f7c0405343028a062aeb521b9c7726.webp";